import * as React from 'react'
import { FC } from 'react'
import { useStyles } from './styling'
import { useGetBillToOnMount } from '@user/store/entityLocations/hooks/useGetBillToOnMount'
import { BillToSelectCardContents } from '../BillToSelect/BillToRadioCard/BillToRadioCardContents/BillToRadioCardContents'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

export interface Props {
  billToId: string
  headerContent?: React.ReactNode
  maxWidth?: string
  width?: string
}

export const BillToCardBasic: FC<Props> = (props: Props) => {
  const { billToId, headerContent } = props
  const { billTo, loadingStatus } = useGetBillToOnMount(billToId)

  const [classes, styles] = useStyles(
    props.maxWidth ?? '431px',
    props.width ?? 'auto',
  )

  return (
    <Card sx={classes.card} style={styles.card}>
      {loadingStatus === 'pending' || !billTo ? (
        <Box sx={classes.loadingBox}>
          <CircularProgress />
        </Box>
      ) : (
        <BillToSelectCardContents
          headerContent={headerContent}
          location={billTo}
        />
      )}
    </Card>
  )
}
